import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { lastValueFrom } from 'rxjs';

export interface StatisticsDto {
  allTimeAppBuilds: number;
  allTimeAppBundleDownloads: number;
  allTimeAppDeployments: number;
  currentMonthAppDevices: number;
  allTimeUptimeInPercent: number;
  lastMonthAppBundleDownloads: number;
  lastMonthAppBuilds: number;
  lastMonthAppDeployments: number;
  lastMonthUsers: number;
  updatedAt: string;
}

@Injectable({
  providedIn: 'root',
})
export class ApiStatisticsService {
  private readonly urlPath = '/v1/statistics';

  constructor(private readonly httpClient: HttpClient) {}

  public async find(): Promise<StatisticsDto> {
    if (environment.production) {
      const response$ = this.httpClient.get<StatisticsDto>(
        environment.apiBaseUrl + this.urlPath,
      );
      return lastValueFrom(response$);
    } else {
      // Mocked data for non-production environments
      return {
        allTimeAppBuilds: 500_000,
        allTimeAppBundleDownloads: 10_000_000,
        allTimeAppDeployments: 2_000_000,
        currentMonthAppDevices: 2_000_000,
        allTimeUptimeInPercent: 99.99,
        lastMonthAppBundleDownloads: 5_000_000,
        lastMonthAppBuilds: 50_000,
        lastMonthAppDeployments: 10_000,
        lastMonthUsers: 500,
        updatedAt: new Date().toISOString(),
      };
    }
  }
}
